import * as scrollLock from './scroll-lock-master/dist/scroll-lock.min.js';

let blockUiOpen = false;
const initBlockUI = ($form, close = false, overlay) => {

	if (!overlay) {
		overlay = {
			backgroundColor: 'rgb(255,255,255)',
			opacity: '0.9',
		}
	}
	if (close) {
		$.unblockUI();
		$('.overlow-block').removeClass('hidden-overflow');
		$('.popup').removeClass('visible').addClass('hidden-block');
		blockUiOpen = false;
	} else {
		$.blockUI({
			message: $form,
			onOverlayClick: $.unblockUI,
			onBlock: function(){
				$('.overlow-block').addClass('hidden-overflow');
				blockUiOpen = true;
				$form.removeClass('hidden-block');
				scrollLock.disablePageScroll();
				
			},
			onUnblock: function(){
				$('.overlow-block').removeClass('hidden-overflow');
				blockUiOpen = false;
				scrollLock.enablePageScroll();
			},
				css: {
				border:0,
				centerY: false,
				position:'fixed',
				padding: 0,
				cursor: 'default',
				left: '0%',
				top: 0,
				zIndex: '2000',
				right: '0%',
				width:'100%',
				height: '100%',
				marginBottom: '0',
				marginTop: '0',
				background: 'none',
				textAlign: 'left',
				overflow: 'auto',
			},
				overlayCSS: {
					backgroundColor: overlay.backgroundColor,
					opacity: overlay.opacity,
					zIndex: '1050',
					'cursor': 'default'
			},
			focusInput: false
		});
		if (!$form.hasClass('not-center')) {
			const center = ($form) => {

				setTimeout(() => {
					$form.center($form);
					$form.addClass('visible');

					const windowWidth = $(window).width() / 2;
					const formWidth = $form.width() / 2;
					const centerWidth = windowWidth - formWidth;
					if ($(window).width() >= 1200) {
						$form.css('left', centerWidth);
					}

				},300);
			}
			center($form);
	    }
	}
}
let $form;

$(document).on('click', '.js-show-popup', function(e) {
	e.preventDefault();
	$form = $('.js-'+ $(this).data('form-class'));
	let overlay = $(this).data('overlay');
	initBlockUI($form, false, overlay);
});
/*CLOSE FORM*/
$(document).on('click touchstart','.js-close-form', function() {
    initBlockUI($form,true);
});
$(document).on('click touchstart', function(e) {
	let $target = $(e.target);

	// if (blockUiOpen && ($target.closest('.popup').length === 0)) {
	// 	initBlockUI($form,true);
	// }
});
$(document).keyup(function(e) {
	if (e.keyCode == 27) {
		initBlockUI($form,true);
	}
});
/*CLOSE FORM*/
